module.exports = __webpack_public_path__ + "img/awesome-ship-tattoo-14910727194nk8g.jpg";